import { pxToEm } from 'util/pxToEm';
import { Box, Typography, Checkbox } from '@mui/material';
import React, { ReactElement } from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { FormErrors } from 'components/ui';
import { FeedbackFormData } from '../constants';

export interface QuestionsSectionProps {
  questions: Array<{ id: string; question: string }>;
  selectedQuestionIds: string[];
  control: Control<FeedbackFormData>;
  setValue: UseFormSetValue<FeedbackFormData>;
  errors: FieldErrors<FeedbackFormData>;
  readOnly?: boolean;
}

export const QuestionsSection = ({
  questions,
  selectedQuestionIds,
  setValue,
  errors,
  readOnly = false,
}: QuestionsSectionProps): ReactElement => {
  if (questions.length === 0)
    return <></>;


  const handleQuestionToggle = (questionId: string) => {
    if (readOnly) return;
    const newIds = selectedQuestionIds.includes(questionId)
      ? selectedQuestionIds.filter(id => id !== questionId)
      : [...selectedQuestionIds, questionId];
    setValue('selectedQuestionIds', newIds, {
      shouldValidate: true,
    });
  };

  return (
    <Box mb={40}>
      <Typography
        sx={{
          fontSize: pxToEm(16),
          fontWeight: 500,
          mb: 8,
          color: '#383838',
        }}
      >
        What did you learn?
      </Typography>
      <Box display="flex" flexDirection="column" gap={12}>
        {questions.map(question => (
          <Box
            key={question.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              padding: '13.5px 16px',
              cursor: readOnly ? 'default' : 'pointer',
              border: '1px solid #DEDEDE',
              borderRadius: '10px',
              '&:hover': {
                backgroundColor: readOnly ? 'transparent' : 'rgba(0,0,0,0.02)',
              },
            }}
            onClick={() => handleQuestionToggle(question.id)}
          >
            <Typography
              sx={{
                fontSize: pxToEm(14),
                fontWeight: 400,
                flex: 1,
                color: '#23305F',
              }}
            >
              {question.question}
            </Typography>
            <Checkbox
              checked={selectedQuestionIds.includes(question.id)}
              onChange={e => {
                e.stopPropagation();
                handleQuestionToggle(question.id);
              }}
              disabled={readOnly}
              sx={{
                padding: 0,
                marginLeft: 16,
              }}
            />
          </Box>
        ))}
      </Box>
      {!readOnly && errors.selectedQuestionIds && (
        <FormErrors sx={{ mt: 8 }}>
          Please select at least one option
        </FormErrors>
      )}
    </Box>
  );
};

